import { render } from "./product_view.html?vue&type=template&id=1b7166ff&external"
import script from "./product_view.js?vue&type=script&lang=js&external"
export * from "./product_view.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__